module.exports = __webpack_public_path__ + "img/oliver-borner1.97fbe6fe.jpg";